import { useTranslation } from 'react-i18next'
import { FooterProps } from 'src/components/Footer'

const useFooter: () => Omit<FooterProps, 'menu' | 'legals'> = () => {
  const { t } = useTranslation()
  return {
    logos: [
      {
        linkProps: null,
        imageProps: {
          src: '/images/header/logo-republique-francaise.svg',
          alt: 'République française',
          width: 80,
          height: 80,
          layout: 'intrinsic',
        },
      },
      {
        linkProps: {
          href: 'https://www.santepubliquefrance.fr/',
          target: '_blank',
          title: 'Site de la Santé Publique Française',
          rel: 'noreferrer',
        },
        imageProps: {
          src: '/images/header/logo-sante-publique.svg',
          alt: 'Santé Publique Française',
          width: 110,
          height: 80,
          layout: 'intrinsic',
        },
      },
    ],
    logoMain: {
      linkProps: {
        href: process.env.MANGER_BOUGER_ROOT || '/',
        title: "Retour à la page d'accueil",
      },
      imageProps: {
        src: '/images/Footer/Logo.svg',
        alt: 'Manger Bouger',
        width: 150,
        height: 80,
        layout: 'intrinsic',
      },
    },
    socials: [
      {
        actionProps: {
          href: t('socials_facebook_url'),
        },
        text: 'Facebook',
        icon: 'socialFacebook',
        variantColor: 'green',
        variantType: 'link',
        variantColorScheme: 'iconWhite',
        variantIcon: 'only',
      },
      {
        actionProps: {
          href: t('socials_instagram_url'),
        },
        text: 'Instagram',
        icon: 'socialInstagram',
        variantColor: 'green',
        variantType: 'link',
        variantColorScheme: 'iconWhite',
        variantIcon: 'only',
      },
    ],
  }
}

export default useFooter
